export namespace VorlagenConfigTypes {
    export const VORLAGEN_MANDANT_OPTIONS = 'vorl-vorlagen';
    
}

